import { QuoteFinancialAttachment } from '../constants/common'
import { ShrtflConfig } from './configs/shrtfl'
import FinancialIndicator from './financialIndicator'

class Shrtfl extends FinancialIndicator {
  static config = ShrtflConfig

  getComputedValuesAtDateIndex(dateIndex: number) {
    const { timestampToFinancialsIndexesMap, alignedFinancialAttachmentsData } = this.data
    const timestampKey = this.data.date[dateIndex]?.toString() ?? ''
    const sourceIndexes = timestampToFinancialsIndexesMap[QuoteFinancialAttachment.shortInterest]?.[timestampKey] ?? []
    const alignedData = alignedFinancialAttachmentsData[QuoteFinancialAttachment.shortInterest] ?? []
    let isBeforeData = false

    if (sourceIndexes.length === 0 && dateIndex === 0) {
      const lastBeforeDateFinancialsDataIndex = alignedData.findLastIndex(
        ({ timestamp }) => timestamp < this.data.date[dateIndex]
      )
      if (lastBeforeDateFinancialsDataIndex >= 0) {
        sourceIndexes.push(lastBeforeDateFinancialsDataIndex)
        isBeforeData = true
      }
    }

    return sourceIndexes.map((si) => {
      const { timestamp, shortInterest, sharesFloat } = alignedData[si]
      let value: number | null = null
      if (shortInterest !== null && sharesFloat !== null) {
        value = (shortInterest / sharesFloat) * 100
      }

      return {
        isBeforeData,
        timestamp,
        value,
        sourceIndex: si,
      }
    })
  }

  renderYAxis(context: CanvasRenderingContext2D, options: { lastValueSuffix?: string } = {}) {
    return super.renderYAxis(context, { ...options, lastValueSuffix: '%' })
  }

  getValueLabel(value: number | null | undefined) {
    return super.getValueLabel(value, '%')
  }

  getIsValid(): boolean {
    return true
  }
}

export default Shrtfl
